import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button, MenuItem, CircularProgress } from '@mui/material';
import { getWarehouses } from 'api/warehouse/get-warehouses';
import { GetWarehousesVm } from 'api/warehouse/get-warehouses.vm';
import { WarehouseVm } from 'api/warehouse/warehouse.vm';

interface RegisterStationDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (name: string, warehouseId: string, externalId?: string) => void;
}

export const RegisterStationDialog: React.FC<RegisterStationDialogProps> = ({ open, onClose, onSubmit }) => {
  const [warehouses, setWarehouses] = useState<WarehouseVm[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [station, setStation] = useState({
    warehouseId: '',
    name: '',
    externalId: '',
  });

  useEffect(() => {
    if (open) {
      fetchWarehouses();
      setStation({ warehouseId: '', name: '', externalId: '' });
    }
  }, [open]);

  const fetchWarehouses = async () => {
    setLoading(true);
    setError(null);
    getWarehouses('', {
      success: function (data: GetWarehousesVm): void {
        setWarehouses(data.objects);
        setLoading(false);
      },
      error: function (err: Error) {
        console.error('Falha ao obter armazéns:', err);
        setError('Falha ao carregar armazéns');
        setLoading(false);
      },
    });
  };

  const handleSubmit = () => {
    const externalId = station.externalId.trim();
    onSubmit(station.name, station.warehouseId, externalId || undefined);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Nova Estação</DialogTitle>
      <DialogContent>
        {loading ? (
          <CircularProgress />
        ) : error ? (
          <div style={{ color: 'red', margin: '16px 0' }}>{error}</div>
        ) : (
          <>
            <TextField
              select
              margin="dense"
              label="Armazém"
              fullWidth
              variant="outlined"
              value={station.warehouseId}
              onChange={(e) => setStation({ ...station, warehouseId: e.target.value })}
              sx={{ mb: 1 }}
            >
              <MenuItem value="">
                <em>Selecione um armazém</em>
              </MenuItem>
              {warehouses.map((warehouse: WarehouseVm) => (
                <MenuItem key={warehouse.id} value={warehouse.id}>
                  {warehouse.id} - {warehouse.name}
                </MenuItem>
              ))}
            </TextField>
            <TextField
              margin="dense"
              label="Nome da Estação"
              fullWidth
              variant="outlined"
              value={station.name}
              onChange={(e) => setStation({ ...station, name: e.target.value })}
              sx={{ mb: 1 }}
            />
            <TextField
              margin="dense"
              label="ID Externo"
              fullWidth
              variant="outlined"
              value={station.externalId}
              onChange={(e) => setStation({ ...station, externalId: e.target.value })}
              placeholder="ID da estação no sistema Kardex (opcional)"
              sx={{ mb: 2 }}
            />
          </>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button onClick={handleSubmit} variant="contained" disabled={!station.warehouseId || !station.name || loading}>
          Criar Estação
        </Button>
      </DialogActions>
    </Dialog>
  );
};
